import { useState, useEffect } from "react";

export default function useStateHandler(
  st: number,
  t: number,
  a: boolean,
) {
  const [cardAnim, setCardAnim] = useState<boolean>(false);
  const [isClickable, setIsClickable] = useState<boolean>(false);
  const [win, setWin] = useState<boolean>(false);

  useEffect(() => {
    let myTimeout: any;
    switch (st) {
      case 1:
        setCardAnim(false);
        break;
      case 2:
      case 3:
      case 5:
        if (!a) {
          myTimeout = setTimeout((t) => {
            setCardAnim(true);
          }, t + 250);
        } else {
          setCardAnim(true);
          clearTimeout(myTimeout);
        }
        break;
      case 7:
        setCardAnim(true);
        break;
      default:
        break;
    }
  }, [st, t, a]);

  useEffect(() => {
    st === 2 ? setIsClickable(true) : setIsClickable(false);
  }, [st]);

  useEffect(() => {
    cardAnim
      ? setTimeout(() => {
          setWin(true);
        }, t)
      : setWin(false);
  }, [cardAnim, t]);

  return { cardAnim, isClickable, win };
}
